<template>
  <g clip-path="url(#smallinfo)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 12.5C9.31371 12.5 12 9.81371 12 6.5C12 3.18629 9.31371 0.5 6 0.5C2.68629 0.5 0 3.18629 0 6.5C0 9.81371 2.68629 12.5 6 12.5ZM5.25 3.875C5.25 4.28921 5.58579 4.625 6 4.625C6.41421 4.625 6.75 4.28921 6.75 3.875C6.75 3.46079 6.41421 3.125 6 3.125C5.58579 3.125 5.25 3.46079 5.25 3.875ZM6.75 9.125V6.125C6.75 5.71079 6.41421 5.375 6 5.375C5.58579 5.375 5.25 5.71079 5.25 6.125V9.125C5.25 9.53921 5.58579 9.875 6 9.875C6.41421 9.875 6.75 9.53921 6.75 9.125Z"
    />
  </g>
  <defs>
    <clipPath id="smallinfo">
      <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</template>
